import React, { Suspense } from "react";

import { sendLog } from "@lambdatest/frontend-logger";
import { LTLoader } from "@lambdatestincprivate/lt-components";
import { EventSourcePolyfill } from "event-source-polyfill";

import throttle from "lodash/throttle";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

import { connect } from "react-redux";
import { Navigate, Route, Router, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import { IN_PROGRESS, SUCCESS } from "../../common/constants/Auth";
import ComponentError from "../../components/ComponentError";
import {
  deleteFromList,
  getBuild,
  updateBuildField,
  updateBuildList
} from "../../redux/actions/lambdaTestBuildDataActions";
import {
  SSE_fetchConcurrencyDetails,
  fetchConcurrencyDetails
} from "../../redux/actions/lambdaTestConcurrencyActions";
import {
  addTestData,
  removeTestData,
  updateTestData,
  updateTestListData
} from "../../redux/actions/lambdaTestTestDataActions";
import { setPromoBannerHeight } from "../../redux/actions/lambdaTestTestDetailActions";
import { addRealtimeCommandLog } from "../../redux/actions/ml2.0/commandLogs";
import {
  deleteTest,
  fetchCypressTestCount,
  updateTestLists
} from "../../redux/actions/testArchives";
import {
  fetchUserInfo,
  fetchOnPremFeatureFlags
} from "../../redux/actions/userInfoActions";
import { getCookieData } from "../../utility/cookieHandler/handler";
import {
  getQueryStringValue,
  parseJwt,
  isRenderingInTestDrawerFlagEnabled,
  getUrlObject,
  isNewCypressTestViewEnabled
} from "../../utility/utilityFunctions";

import ErrorBoundary from "../../components/ErrorBoundary";
import ComponentTraceLoader from "../../components/ml2.0/ComponentTraceLoader";

import {
  BuildTestTabs,
  BuildTestTabs as PrimerBuildTestTabs,
  TestTypes
} from "../../common/constants/View";
import {
  updateTestDetailHashmapSSE,
  updateTestDetailSessionId
} from "../../redux/actions/lambdaTestTestDetailActions";
import {
  getUrlByUserDomain,
  isSharingRoute,
  isTmsMergerEnabled
} from "../../utility/utilityFunctions";

import SharedPageWrapper from "../../containers/ml2.0/SharedPageWrapper";
import { fetchOrgPreferences } from "../../redux/actions/orgPreferencesActions";
import {
  isNewBuildFilterCompliant,
  isNewTestFilterCompliant
} from "../../utility/testHelpers";
import "./App.css";
import styles from "./index.module.css";
import { updateTestAttempts } from "../../redux/actions/rerunTestActions";
import { getTestStatusCount } from "../../redux/actions/lambdaTestSidebarTestListActions";
import {
  updateCypressGroupedData,
  updateCypSidebarGroupedData
} from "../../redux/actions/cypressGroupedTestActions";

const LogsPage = React.lazy(() => import("../../containers/ml2.0/LogsPage"));
const OnboardUserFlowPage = React.lazy(() => import("../OnboardUserFlowPage"));
const OnboardUser = React.lazy(() => import("../ml2.0/OnboardUser"));
const OnboardNew = React.lazy(() => import("../../components/OnboardNew"));
const OnboardingViewFrameworkResults = React.lazy(() =>
  import("../../components/OnboardingViewFrameworkResults")
);

const TestDetailPageWrapper = React.lazy(() =>
  import("../ml2.0/TestDetailPageWrapper")
);

const PrimerAutomationPageV3 = React.lazy(() =>
  import("../../containers/ml2.0/AutomationPageV3")
);

const getBuildDataOnUpdate = sseData => {
  const {
    buildId,
    buildType,
    createdDate,
    createdAt,
    endedAt,
    name,
    updateTimestamp,
    status,
    buildTestCountData,
    username
  } = sseData || {};

  const {
    build_duration,
    cancelled,
    completed,
    error,
    failed,
    initiated,
    lambdaError,
    passed,
    queued,
    running,
    stopped,
    timeout,
    total
  } = buildTestCountData;
  return {
    buildId,
    username,
    name,
    type: buildType,
    createdDate,
    createdAt,
    endedAt,
    updateTimestamp,
    seconds: Number(build_duration) || null,
    buildStatus: status,
    tests: total,
    cancelled: Number(cancelled),
    completed: Number(completed),
    error: Number(error),
    failed: Number(failed),
    initiated: Number(initiated),
    lambdaError: Number(lambdaError),
    passed: Number(passed),
    queued: Number(queued),
    running: Number(running),
    stopped: Number(stopped),
    timeout: Number(timeout)
  };
};

const getBuildOnTestCreate = sseData => {
  const { buildDetails } = sseData;
  const {
    username,
    name,
    createdAt,
    endedAt,
    status,
    buildType
  } = buildDetails;
  return {
    buildStatus: status,
    type: buildType,
    name,
    username,
    createdAt,
    endedAt
  };
};

const getTestOnTestCreate = testSSE => {
  const testData = { ...testSSE };
  const buildDetails = testData?.buildDetails;
  delete testData.buildDetails;
  testData.buildName = buildDetails.name;
  return testData;
};

export class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      downTime: true,
      selectedBuild: null
    };
    this.testIdListRef = React.createRef({});

    this.buildIdListRef = React.createRef({});
    this.buildIdListRef.current = {};
    this.buildIdListTime = React.createRef(null);
    this.buildIdListTime.current = null;

    this.testListRef = React.createRef({});
    this.testListRef.current = {};
    this.updateTestListRef = React.createRef({});
    this.updateTestListRef.current = null;

    this.buildtestlist = React.createRef({});
    this.buildtestlist.current = {};
  }

  componentDidMount = async () => {
    const {
      addTestData,
      auth,
      automationApiHost,
      fetchCypressTestCount,
      fetchUserInfo,
      getBuild,
      getTestStatusCount,
      removeTestData,
      SSE_fetchConcurrencyDetails,
      sidebarTestList,
      testTimelineFilter,
      updateBuildField,
      updateTestData,
      updateTestDetailHashmapSSE,
      updateTestLists,
      updateCypressGroupedData,
      updateCypSidebarGroupedData,
      deleteTest,
      updateBuildList,
      deleteFromList,
      updateTestAttempts,
      updateTestListData,
      updateTestDetailSessionId
    } = this.props;
    // Fetch information incase onprem is found.

    if (
      process.env.REACT_APP_HIDE_PUBLIC_LINKS &&
      process.env.REACT_APP_HIDE_PUBLIC_LINKS === "true"
    ) {
      await this.fetchUserInfoForOnPrem();
    }
    const cookieName = process.env.REACT_APP_COOKIE_NAME;
    const access_token = getCookieData(cookieName);
    const urlSegments = window.location.href.split("/");
    const jwtDecode = access_token ? parseJwt(access_token) : null;
    let username = jwtDecode && jwtDecode.username ? jwtDecode.username : null;

    if (!isSharingRoute()) {
      if ((!access_token || !username) && urlSegments[3] !== "jenkins") {
        window.location.href =
          process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
        return false;
      }

      if (urlSegments[3] !== "jenkins") {
        fetchUserInfo().then(data => {
          if (window.sumoLogicOpenTelemetryRum) {
            const userData = data["data"];
            window.sumoLogicOpenTelemetryRum.setDefaultAttribute(
              "userId",
              userData["id"]
            );
            window.sumoLogicOpenTelemetryRum.setDefaultAttribute(
              "orgId",
              userData["organization"]["id"]
            );
            window.sumoLogicOpenTelemetryRum.setDefaultAttribute(
              "subscriptionType",
              userData["organization"]["subscription_type"]
            );
          }
        });
        if (!isTmsMergerEnabled()) {
          fetchConcurrencyDetails({
            automationApiHost: this.props.automationApiHost
          });
        }
      } else {
        username = getCookieData("username");
      }
    }

    let queue = {};

    const fetchConcurrencyThrottled = throttle(() => {
      if (!isTmsMergerEnabled()) {
        SSE_fetchConcurrencyDetails();
      }
    }, 5000);

    const fetchTestStatusThrottled = throttle(automationLogs => {
      getTestStatusCount(automationLogs);
    }, 5000);

    const getBuildThrottled = throttle(function(buildId) {
      getBuild(buildId);
    }, 5000);
    const shouldRemoveSSEEvents =
      (process.env.REACT_APP_HIDE_PUBLIC_LINKS &&
        process.env.REACT_APP_HIDE_PUBLIC_LINKS === "true") ||
      isSharingRoute();
    if (!shouldRemoveSSEEvents) {
      const isFirefoxBrowser = window.navigator.userAgent.includes("Firefox");
      let es;
      if (isFirefoxBrowser) {
        es = new EventSourcePolyfill(
          `${getUrlByUserDomain(
            process.env.REACT_APP_SSE_URL_PREFIX,
            "https",
            process.env.REACT_APP_HIDE_PUBLIC_LINKS
          )}/api/v1/sse/automation`,
          {
            withCredentials: true
          }
        );
      } else {
        es = new EventSource(
          `${getUrlByUserDomain(
            process.env.REACT_APP_SSE_URL_PREFIX,
            "https",
            process.env.REACT_APP_HIDE_PUBLIC_LINKS
          )}/api/v1/sse/automation`,
          {
            withCredentials: true
          }
        );
      }

      es.onmessage = event => {
        const data = event.data ? JSON.parse(event.data) : null;

        if (!data) {
          console.log("no Data");
        } else {
          const event_name = data.event;
          const test_id = data.testId;
          const buildId = data.buildId;
          const sseUsername = data.username;
          const isTeamManagementEnabled = this.props.userInfo?.data
            ?.organization?.team_management_enabled;
          sendLog({
            logDetails: {
              componentName: "SSE Events",
              data: data,
              build_id: buildId
            },
            logLevel: "Info",
            serviceName: "MagicLeap - Dashboard"
          });
          switch (event_name) {
            case "TEST_CREATED": {
              if (!isTeamManagementEnabled || username === sseUsername) {
                const currentPath = window.location.pathname;
                const isBuildFilterCompliant = isNewBuildFilterCompliant(
                  data,
                  this.props.timelineFilter,
                  this.props.buildList
                );
                const isTestFilterCompliant = isNewTestFilterCompliant(
                  data,
                  this.props.testTimelineFilter
                );
                if (!queue[test_id] || queue[test_id] !== event_name) {
                  queue[test_id] = event_name;
                  fetchConcurrencyThrottled();
                  const newTestData = data;
                  const testId = data.testId;
                  const buildId = data.buildId;
                  const testName = data.name;
                  const parentTestId = data.parentTestId;
                  const testType = data.type;
                  delete newTestData.event;
                  newTestData.id = testId;

                  const isNewCypressTestView =
                    isNewCypressTestViewEnabled(this.props.featureFlags.data) &&
                    (testType === TestTypes.CYPRESS ||
                      testType === TestTypes.HYPERTEST_CYPRESS);

                  const urlBuildId = getQueryStringValue("build");

                  if (currentPath === "/test") {
                    const isTestFilterCompliant = isNewTestFilterCompliant(
                      data,
                      this.props.automationLogs
                    );
                    const urlTestId = getQueryStringValue("testID");

                    if (urlTestId && urlTestId === parentTestId) {
                      window.open(
                        `/test?build=${buildId}&testID=${testId}&isRerunTest=true`,
                        "_self"
                      );
                    }

                    if (buildId.toString() === urlBuildId) {
                      if (!isTestFilterCompliant) {
                        removeTestData(newTestData);
                        if (this.buildtestlist.current[testId]) {
                          delete this.buildtestlist.current[testId];
                        }
                      } else {
                        this.buildtestlist.current[testId] = newTestData;
                      }

                      if (!this.testPageListTimeout) {
                        let cypressTestData = {};
                        this.testPageListTimeout = setTimeout(() => {
                          Object.keys(this.buildtestlist.current).forEach(
                            id => {
                              if (
                                !isNewTestFilterCompliant(
                                  this.buildtestlist.current[id],
                                  this.props.automationLogs
                                )
                              ) {
                                delete this.buildtestlist.current[id];
                              } else {
                                if (isNewCypressTestView) {
                                  if (
                                    this.props.activeCypressAccordion ===
                                    this.buildtestlist.current[id]?.name
                                  ) {
                                    cypressTestData = {
                                      ...cypressTestData,
                                      [id]: this.buildtestlist.current[id]
                                    };
                                  }
                                }
                              }
                            }
                          );

                          if (isNewCypressTestView) {
                            // to add cypress spec group via sse
                            updateTestListData(
                              this.buildtestlist.current,
                              isNewCypressTestView
                            );
                            if (!isEmpty(cypressTestData)) {
                              updateCypSidebarGroupedData(cypressTestData);
                            }
                          } else {
                            updateTestListData(this.buildtestlist.current);
                          }

                          this.buildtestlist.current = {};
                          this.testPageListTimeout = null;
                        }, 3000);
                      }
                    }
                  } else if (currentPath === "/build") {
                    const isTestListingPage =
                      getQueryStringValue("pageType") === "test";

                    if (isTestListingPage && isTestFilterCompliant) {
                      this.testListRef.current[testId] = getTestOnTestCreate(
                        newTestData
                      );

                      if (!this.updateTestListRef.current) {
                        this.updateTestListRef.current = setTimeout(() => {
                          let cypressTestData = {};

                          console.log("s123", urlBuildId);

                          // only update test in the list if the accordion is open, since data is not fetched for closed accordion
                          if (isNewCypressTestView && urlBuildId) {
                            Object.keys(this.testListRef.current).forEach(
                              id => {
                                if (
                                  this.props.activeCypressAccordion ===
                                  this.testListRef.current[id]?.name
                                ) {
                                  cypressTestData = {
                                    ...cypressTestData,
                                    [id]: this.testListRef.current[id]
                                  };
                                }
                              }
                            );

                            fetchCypressTestCount({
                              token: auth.token,
                              automationApiHost: automationApiHost,
                              buildId: urlBuildId,
                              filter: testTimelineFilter
                            });

                            if (!isEmpty(cypressTestData)) {
                              updateCypressGroupedData(
                                this.testListRef.current
                              );
                            }
                          } else {
                            updateTestLists(this.testListRef.current);
                          }
                          this.testListRef.current = {};
                          this.updateTestListRef.current = null;
                        }, 500);
                      }
                    } else {
                      if (isBuildFilterCompliant) {
                        const updateData = {};
                        const isNewBuild =
                          data.createdAt === data.buildDetails.createdAt;
                        updateData[buildId] = {
                          buildId: buildId,
                          ...getBuildOnTestCreate(data)
                        };
                        updateBuildList(updateData, isNewBuild);
                      } else {
                        // for an existing build, if a new test is run, build status will change to running, so update build in the list
                        deleteFromList(buildId);
                      }
                    }
                  }
                }
              }
              break;
            }

            case "TEST_UPDATED": {
              if (!isTeamManagementEnabled || username === sseUsername) {
                const currentPath = window.location.pathname;
                const isTestFilterCompliant = isNewTestFilterCompliant(
                  data,
                  this.props.testTimelineFilter
                );
                const newTestData = data;
                const testId = data.testId;
                const status = data.status;
                const testName = data.name;
                const testType = data.type;
                delete newTestData.event;
                delete newTestData.testId;
                newTestData.id = testId;

                const isNewCypressTestView =
                  isNewCypressTestViewEnabled(this.props.featureFlags.data) &&
                  (testType === TestTypes.CYPRESS ||
                    testType === TestTypes.HYPERTEST_CYPRESS);

                const urlBuildId = getQueryStringValue("build");

                if (currentPath === "/test") {
                  const isTestFilterCompliant = isNewTestFilterCompliant(
                    newTestData,
                    this.props.automationLogs
                  );

                  if (
                    newTestData &&
                    get(newTestData, "id", "") ===
                      get(
                        this.props.lambdaTestTestDetailHashMap,
                        ["data", "id"],
                        "-"
                      ) &&
                    isTestFilterCompliant
                  ) {
                    updateTestDetailHashmapSSE(newTestData);
                  }

                  if (buildId.toString() === urlBuildId) {
                    // call this function to update the test status count
                    fetchTestStatusThrottled(this.props.automationLogs);
                    if (!isTestFilterCompliant) {
                      removeTestData(newTestData);
                      if (this.buildtestlist.current[testId]) {
                        delete this.buildtestlist.current[testId];
                      }
                    } else {
                      this.buildtestlist.current[testId] = newTestData;
                    }

                    if (!this.testPageListTimeout) {
                      let cypressTestData = {};
                      this.testPageListTimeout = setTimeout(() => {
                        Object.keys(this.buildtestlist.current).forEach(id => {
                          if (
                            !isNewTestFilterCompliant(
                              this.buildtestlist.current[id],
                              this.props.automationLogs
                            )
                          ) {
                            delete this.buildtestlist.current[id];
                          } else {
                            if (isNewCypressTestView) {
                              if (
                                this.props.activeCypressAccordion ===
                                this.buildtestlist.current[id]?.name
                              ) {
                                cypressTestData = {
                                  ...cypressTestData,
                                  [id]: this.buildtestlist.current[id]
                                };
                              }
                            }
                          }
                        });
                        if (isNewCypressTestView) {
                          updateTestListData(
                            this.buildtestlist.current,
                            isNewCypressTestView
                          );
                          if (!isEmpty(cypressTestData)) {
                            updateCypSidebarGroupedData(cypressTestData);
                          }
                        } else {
                          updateTestListData(this.buildtestlist.current);
                        }
                        this.buildtestlist.current = {};
                        this.testPageListTimeout = null;
                      }, 3000);
                    }
                  }
                } else {
                  if (
                    isRenderingInTestDrawerFlagEnabled(
                      this.props.featureFlags.data
                    ) &&
                    getQueryStringValue("testID") === testId
                  ) {
                    // Update test details for the test which is open on drawer when SSE changes are detected.
                    updateTestDetailHashmapSSE(newTestData);
                  }
                  const isTestListPage =
                    getQueryStringValue("pageType") === "test";

                  if (!isTestFilterCompliant) {
                    deleteTest(testId);
                  }

                  if (isTestListPage && isTestFilterCompliant) {
                    if (this.testListRef.current[testId]) {
                      this.testListRef.current[testId] = {
                        ...this.testListRef.current[testId],
                        ...newTestData
                      };
                    } else {
                      this.testListRef.current[testId] = getTestOnTestCreate(
                        newTestData
                      );
                    }

                    if (!this.updateTestListRef.current) {
                      this.updateTestListRef.current = setTimeout(() => {
                        let cypressTestData = {};

                        // only update test in the list if the accordion is open, since data is not fetched for closed accordion
                        if (isNewCypressTestView && urlBuildId) {
                          Object.keys(this.testListRef.current).forEach(id => {
                            if (
                              this.props.activeCypressAccordion ===
                              this.testListRef.current[id]?.name
                            ) {
                              cypressTestData = {
                                ...cypressTestData,
                                [id]: this.testListRef.current[id]
                              };
                            }
                          });

                          fetchCypressTestCount({
                            token: auth.token,
                            automationApiHost: automationApiHost,
                            buildId: urlBuildId,
                            filter: testTimelineFilter
                          });

                          if (!isEmpty(cypressTestData)) {
                            updateCypressGroupedData(this.testListRef.current);
                          }
                        } else {
                          updateTestLists(this.testListRef.current);
                        }
                        this.testListRef.current = {};
                        this.updateTestListRef.current = null;
                      }, 500);
                    }
                  }
                }

                fetchConcurrencyThrottled();
              }
              break;
            }

            case "BUILD_UPDATED": {
              const buildData = { ...data, buildDetails: data };
              const isBuildFilterCompliant = isNewBuildFilterCompliant(
                buildData,
                this.props.timelineFilter,
                this.props.buildList
              );
              if (window.location.pathname === "/build") {
                const isTestListPage =
                  getQueryStringValue("pageType") === "test";

                if (!isBuildFilterCompliant) {
                  deleteFromList(buildId);
                }

                if (!isTestListPage && isBuildFilterCompliant) {
                  if (!this.buildIdListTime.current) {
                    this.buildIdListRef.current[buildId] = getBuildDataOnUpdate(
                      data
                    );

                    this.buildIdListTime.current = setTimeout(() => {
                      updateBuildList(
                        this.buildIdListRef.current,
                        false, // isNewBuild = false
                        true // isTestUpdatedEvent = true
                      );
                      this.buildIdListTime.current = null;
                      this.buildIdListRef.current = {};
                    }, 1000);
                  }
                }
              }
              break;
            }

            case "QUEUE_UPDATED": {
              queue[test_id] = event_name;
              break;
            }

            case "SESSION_UPDATED": {
              const currentPath = window.location.pathname;
              if (currentPath === "/test") {
                const testId = data.testId;
                const sessionId = data.sessionId;
                if (
                  testId &&
                  this.props.lambdaTestTestDetailHashMap.data.id === testId
                ) {
                  updateTestDetailSessionId(sessionId);
                }
              }
              break;
            }

            default:
              return false;
          }
        }
      };

      /**
       * this event listener will be remove after 100% rollout of feature flag ml_mp4_video_live_command_log
       */
      es.addEventListener("CDPCommandLog", e => {
        e.data && this.handleRealTimeLogs(JSON.parse(e.data));
      });
    }

    window.addEventListener("TopPromoInitialized", this.handleTopPromoBanner);
  };

  componentWillUnmount = () => {
    window.removeEventListener(
      "TopPromoInitialized",
      this.handleTopPromoBanner
    );
  };

  fetchUserInfoForOnPrem = async () => {
    await Promise.all([
      this.props.fetchUserInfo(),
      this.props.fetchOrgPreferences()
    ]).then(res => {
      this.props.fetchOnPremFeatureFlags({
        userInfo: res?.[0]?.data || {}
      });
    });
  };

  handleTopPromoBanner = () => {
    const { setPromoBannerHeight } = this.props;
    const bannerElCloseIcon = document.getElementById("close_top_promo");
    const topPromoElement = document.getElementById("top_promo");
    if (
      bannerElCloseIcon &&
      topPromoElement &&
      topPromoElement.style.display !== "none"
    ) {
      setPromoBannerHeight(42);
      document.addEventListener("closeTopPromo", () => {
        setPromoBannerHeight(0);
      });
    }
  };

  hideFeedbackBtn = currentPath => {
    var isHeaderCollapsed = document.getElementsByClassName(
      "header__collapsed"
    );
  };

  handleRealTimeLogs = sseData => {
    const { addRealtimeCommandLog } = this.props;
    if (window.location.pathname === "/test") {
      const urlTestId = getQueryStringValue("testID");
      if (sseData.test_id !== urlTestId) {
        return;
      }
      addRealtimeCommandLog(sseData);
    }
  };

  componentDidUpdate = prevProps => {
    const { currentSelectedBuild } = this.props;
    if (prevProps.currentSelectedBuild !== currentSelectedBuild) {
      this.setState({ selectedBuild: currentSelectedBuild });
    }
  };

  componentWillMount = () => {
    const cookieName = process.env.REACT_APP_COOKIE_NAME;
    const access_token = getCookieData(cookieName);
    const loginUrl =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
    let currentPath = window.location.pathname;
    currentPath = currentPath.split("/");
    let firstPathSegment = currentPath[1];
    if (
      firstPathSegment === "public" ||
      firstPathSegment === "jenkins" ||
      isSharingRoute()
    ) {
      console.log("public url detected");
    } else if (!access_token) {
      window.location.href = loginUrl;
      return false;
    }
  };

  redirect() {
    if (!this.props.auth || this.props.auth.status !== SUCCESS) {
      return (
        <a
          href={
            process.env.REACT_APP_LOGIN_URL ||
            window?._env_?.REACT_APP_LOGIN_URL
          }
        >
          Authenticating........
          <br />
          If Doesnt Redirect Automatically. Click Here To Redirect
        </a>
      );
    }
  }

  closeDowntimeMessage = () => {
    this.setState({ downTime: false });
  };

  render() {
    let w = window;
    let isIE = /*@cc_on!@*/ false || !!document.documentMode;

    let isEdge = !isIE && !!window.StyleMedia;
    if (isIE && isEdge) {
      console.log("Please Upgrade to Modern Browser.");
      return (window.location.href = "https://www.lambdatest.com/switch.html");
    }

    window.amplitudeData = this.props.featureFlags?.data;

    const isNewThemeEnabledForSharing = window.location.href.includes(
      "isThemeEnabled=true"
    );
    if (isSharingRoute()) {
      return (
        <ErrorBoundary>
          <main
            className="flex"
            style={{
              justifyContent: "center",
              height: "100vh"
            }}
          >
            <Routes>
              <Route
                exact
                path="/share"
                element={
                  <Suspense
                    fallback={
                      isNewThemeEnabledForSharing ? (
                        <LTLoader
                          description="Please wait while we load your automation shared details"
                          heading="Loading Test"
                        />
                      ) : (
                        <ComponentTraceLoader type={`testInfoDetail`} />
                      )
                    }
                  >
                    <SharedPageWrapper />
                  </Suspense>
                }
              />
             <Route
                exact
                path="/share/playwright-trace"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          heading="Loading Playwright Logs"
                        />
                      </div>
                    }
                  >
                   <TestDetailPageWrapper pageType="playwright-trace" />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/share/lighthouse-report"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          heading="Loading Lighthouse Report"
                        />
                      </div>
                    }
                  >
                     <TestDetailPageWrapper pageType="report-view" />
                  </Suspense>
                }
              />
              <Route path="*" element={<ComponentError />} />
            </Routes>
          </main>
        </ErrorBoundary>
      );
    }

    if (this.props.auth && this.props.auth.authorize === IN_PROGRESS) {
      return (
        <Suspense fallback={<></>}>
          <LTLoader />
        </Suspense>
      );
    }
    if (this.props.userInfo && this.props.userInfo.data) {
      if (this.props.userInfo.data.email_verified === false) {
        window.location.href = `${getUrlByUserDomain(
          process.env.REACT_APP_USER_INFO_URL_PREFIX ||
            window?._env_?.REACT_APP_USER_INFO_URL_PREFIX
        )}/email/verify`;
        return null;
      }
    }

    const url = getUrlObject();

    return (
      <>
        <ErrorBoundary>
          <main
            className="flex"
            style={{
              justifyContent: "center",
              height: "100%"
            }}
          >
            <Routes>
              <Route
                exact
                path="/build"
                element={
                  <Suspense fallback={<></>}>
                    <PrimerAutomationPageV3 />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/test"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        {url.searchParams.has("isRerunTest") ? (
                          <LTLoader
                            description="Please wait while we load your Rerun Test"
                            heading="Test Rerun in Progress"
                          />
                        ) : (
                          <LTLoader
                            description="Please wait while we load your automation test details"
                            heading="Loading Test"
                          />
                        )}
                      </div>
                    }
                  >
                    <TestDetailPageWrapper />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/archives"
                element={<Navigate to="/build?pageType=test" />}
              />{" "}
              <Route
                exact
                path="/automation"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          description="Please wait while we load your automation test details"
                          heading="Loading Test"
                        />
                      </div>
                    }
                  >
                    <TestDetailPageWrapper />
                  </Suspense>
                }
              />{" "}
              <Route
                exact
                path="/timeline"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          description="Please wait while we load your automation test details"
                          heading="Loading Test"
                        />
                      </div>
                    }
                  >
                    <TestDetailPageWrapper />
                  </Suspense>
                }
              />{" "}
              <Route
                exact
                path="/testLogs/:testId/:logsType"
                element={
                  <Suspense fallback={<LTLoader />}>
                    <LogsPage />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/logs"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          description="Please wait while we load your automation test details"
                          heading="Loading Test"
                        />
                      </div>
                    }
                  >
                    <TestDetailPageWrapper />
                  </Suspense>
                }
              />{" "}
              <Route exact path="/home" element={<Navigate to="/build" />} />{" "}
              <Route
                exact
                path="/onboarding"
                element={
                  <Suspense
                    fallback={<ComponentTraceLoader type={`firstLoad`} />}
                  >
                    <OnboardUser />
                  </Suspense>
                }
              />{" "}
              <Route
                exact
                path="/onboarding/main"
                element={
                  <Suspense
                    fallback={<ComponentTraceLoader type={`firstLoad`} />}
                  >
                    <OnboardNew />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/configure"
                element={
                  <Suspense
                    fallback={<ComponentTraceLoader type={`firstLoad`} />}
                  >
                    <OnboardUserFlowPage />
                  </Suspense>
                }
              />{" "}
              <Route
                exact
                path="/viewResults"
                element={
                  <Suspense
                    fallback={<ComponentTraceLoader type={`firstLoad`} />}
                  >
                    <OnboardingViewFrameworkResults />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/playwright-trace"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          heading="Loading Playwright Logs"
                        />
                      </div>
                    }
                  >
                    <TestDetailPageWrapper pageType="playwright-trace" />
                  </Suspense>
                }
              />
              <Route
                exact
                path="/lighthouse-report"
                element={
                  <Suspense
                    fallback={
                      <div className={styles.buildLoader}>
                        <LTLoader
                          heading="Loading Lighthouse Report"
                        />
                      </div>
                    }
                  >
                    <TestDetailPageWrapper pageType="report-view" />
                  </Suspense>
                }
              />
              <Route exact path="/error" element={<ComponentError />} />{" "}
              <Route exact path="/error/404" element={<ComponentError />} />{" "}
              <Route exact path="/error/500" element={<ComponentError />} />{" "}
              <Route exact path="/" element={<Navigate to="/build" />} />
              <Route path="*" element={<ComponentError />} />
            </Routes>
          </main>
        </ErrorBoundary>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeCypressAccordion: state.cypressGroupedTest.activeAccordion,
    automationApiHost:
      state.orgPreferencesReducer.orgPreferences.automationApiHost,
    automationLogs: state.filterPersist.automationLogs,
    activeBuildTab: state.lambdaTestBuildData.activeBuildTab,
    auth: state.auth,
    currentSelectedBuild: state.filterPersist.currentSelectedBuild,
    featureFlags: state.userInfo.featureFlags,
    userInfo: state.userInfo.userInfo,
    lambdaTestTestDetailHashMap:
      state.lambdaTestTestDetailHashMap.testDetailHashMap,
    sidebarTestList: state.lambdaTestTestData?.testData?.data,
    timelineFilter: state.filterPersist.timeline,
    testTimelineFilter: state.filterPersist.testTimeline,
    buildList: state.lambdaTestBuildData?.buildData?.data
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addTestData,
      getBuild,
      addRealtimeCommandLog,
      deleteTest,
      deleteFromList,
      fetchOrgPreferences,
      fetchUserInfo,
      fetchOnPremFeatureFlags,
      getTestStatusCount,
      setPromoBannerHeight,
      SSE_fetchConcurrencyDetails,
      fetchConcurrencyDetails,
      fetchCypressTestCount,
      removeTestData,
      updateTestDetailHashmapSSE,
      updateTestData,
      updateBuildField,
      updateTestLists,
      updateCypressGroupedData,
      updateCypSidebarGroupedData,
      updateTestAttempts,
      updateBuildList,
      updateTestListData,
      updateTestDetailSessionId
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
